import { IParkingLocationEntry } from '../../../../contentful/types/IParkingLocationEntry';

export const findParkingPoiPosition = (
	contentfulParkingLocations: IParkingLocationEntry[],
	parkingId: string,
) => {
	const parkingItem = contentfulParkingLocations?.find(
		(p) => p.fields.id === parkingId,
	)?.fields.coordinates;

	if (!parkingItem) {
		return undefined;
	}

	const position = {
		latitude: parkingItem.lat,
		longitude: parkingItem.lon,
	};

	return position;
};
